import _sfc_main from "./IconButton.vue2.mjs";
/* empty css                 */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_setup.themeClass] }, [_c("div", { staticClass: "icon-button-container" }, [_setup.isMobile ? _c("div", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleClickEvent, expression: "handleClickEvent" }], class: ["icon-content", _setup.iconContentClass, `${_vm.disabled && "disabled"}`] }, [_vm._t("default"), _vm.icon ? _c(_setup.SvgIcon, { attrs: { "icon": _vm.icon } }) : _vm._e(), _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])], 2) : _c("div", { class: ["icon-content", _setup.iconContentClass, `${_vm.disabled && "disabled"}`], on: { "click": _setup.handleClickEvent } }, [_vm._t("default"), _vm.icon ? _c(_setup.SvgIcon, { attrs: { "icon": _vm.icon } }) : _vm._e(), _vm.isNotSupport ? _c(_setup.SvgIcon, { staticClass: "unsupport-icon", attrs: { "icon": _setup.UnSupportIcon } }) : _vm._e(), _c("span", { staticClass: "title" }, [_vm._v(" " + _vm._s(_vm.title) + " "), _vm._t("title")], 2)], 2), _vm.hasMore ? _c("div", { ref: "moreSpanRef", staticClass: "icon-arrow", on: { "click": function($event) {
    return _vm.$emit("click-more");
  } } }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.ArrowUp } })], 1) : _vm._e()])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ca48c0e3"
);
const IconButton = __component__.exports;
export {
  IconButton as default
};
